/**
 * KAN-790: поля шага лестницы, которые нужны каналу по его признакам - текст
 * (needs_text, до 200 знаков) и срок исполнения (needs_due, тот же ввод, что
 * у задержки касания).
 */
import { Input } from '@/components/ui/input';
import { NUDGE_DUE_DEFAULT_H, NUDGE_TASK_TEXT_MAX, type NudgeLadderStep } from '@/lib/nudgeLadder';
import { HoursField } from './HoursField';

interface NudgeTaskFieldsProps {
  /** Префикс id контролов строки, уникальный на странице. */
  idPrefix: string;
  testId?: string;
  /** Номер касания с единицы (для подписей). */
  number: number;
  /** Индекс строки (для id и testid, как у остальных контролов строки). */
  index: number;
  step: NudgeLadderStep;
  /** Каналу шага нужен текст. */
  showText: boolean;
  /** Каналу шага нужен срок. */
  showDue: boolean;
  onChange: (patch: Partial<NudgeLadderStep>) => void;
  disabled?: boolean;
}

export function NudgeTaskFields({
  idPrefix,
  testId,
  number,
  index,
  step,
  showText,
  showDue,
  onChange,
  disabled = false,
}: NudgeTaskFieldsProps): JSX.Element {
  return (
    <div className="space-y-1">
      {showText && (
        <Input
          id={`${idPrefix}-text-${index}`}
          data-testid={testId ? `${testId}-text-${index}` : undefined}
          aria-label={`Текст задачи касания ${number}`}
          type="text"
          placeholder="Что сделать"
          maxLength={NUDGE_TASK_TEXT_MAX}
          value={step.text ?? ''}
          disabled={disabled}
          onChange={(e) => onChange({ text: e.target.value })}
        />
      )}
      {showDue && (
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span>Срок</span>
          <HoursField
            id={`${idPrefix}-due-${index}`}
            unitId={`${idPrefix}-due-unit-${index}`}
            testId={testId ? `${testId}-due-${index}` : undefined}
            unitTestId={testId ? `${testId}-due-unit-${index}` : undefined}
            label={`Срок задачи касания ${number}`}
            unitLabel={`Единица срока задачи касания ${number}`}
            hours={step.due_h ?? NUDGE_DUE_DEFAULT_H}
            onChange={(hours) => onChange({ due_h: hours })}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}
